// extracted by mini-css-extract-plugin
export var brand = "_1g-9";
export var compact = "_1g-6";
export var extraSmall = "_1g-7";
export var icon = "_1g-0";
export var large = "_1g-4";
export var light = "_1g-1";
export var medium = "_1g-5";
export var outline = "_1g-b";
export var primaryDark = "_1g-a";
export var primaryLight = "_1g-8";
export var primaryModern = "_1g-c";
export var success = "_1g-2";
export var successSolid = "_1g-3";